import { render } from "./userInfo.vue?vue&type=template&id=49099890&scoped=true"
import script from "./userInfo.vue?vue&type=script&lang=js"
export * from "./userInfo.vue?vue&type=script&lang=js"

import "./userInfo.vue?vue&type=style&index=0&id=49099890&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49099890"]])

export default __exports__